<template>
    <ClientOnly>
        <div class="relative">
            <div id="hubspotForm1" class="hbspt-form hbspt-form-extended"></div>
        </div>
    </ClientOnly>
</template>

<script>
export default {
    name: 'ComplaintReportHubspotForm',
    props: {
        card: {
            type: Boolean,
            required: false,
            default: false,
        },
        game: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mounted() {
        const formId =
            this.$i18n.locale === 'hu'
                ? '9889dc87-0b2d-4fc1-b330-648c95a870d3'
                : 'eeae8a90-8133-4f7e-af9e-36a3b4ec71bb';

        window.hbspt.forms.create({
            portalId: '6087627',
            formId,
            target: '#hubspotForm1',
        });
    },
};
</script>

<style></style>
